require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwitterTimeline = void 0;

var _react = _interopRequireDefault(require("react"));

var _generalObserver = require("../general-observer");

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TwitterTimeline = function TwitterTimeline(_ref) {
  var username = _ref.username,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'light' : _ref$theme,
      _ref$showLikes = _ref.showLikes,
      showLikes = _ref$showLikes === void 0 ? null : _ref$showLikes,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '498px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? null : _ref$height;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTwttrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "twitter-timeline twitter-timeline-mdx-embed",
    "data-theme": theme,
    "data-width": width,
    "data-height": height,
    href: "https://twitter.com/".concat(username).concat(showLikes ? "/likes" : '', "?ref_src=twsrc%5Etfw")
  }, "Tweets by @".concat(username))));
};

exports.TwitterTimeline = TwitterTimeline;